import { AxlePage } from '@/components/layout/AxlePage';
import { VerticalStack } from '@/components/utils/linearLayouts';
import { WHITE } from '@/constants/colors';
import { AxleErrorBoundary, ErrorFallback } from '@/fetching/errorBoundaries';
import { AxleV2Theme } from '@/theme';
import { Children } from '@/utils/reactTypes';
import { Box, ThemeProvider } from '@mui/material';

type PatientDetailsFrameProps = {
    header?: Children;
    rightRail?: Children;
    overlay?: Children;
    children: Children;
};

/* The patient details page's columns and slots, shared by the page and its loading fallback so
   the two keep the same shape. */
export const PatientDetailsFrame = ({
    header,
    rightRail,
    overlay,
    children,
}: PatientDetailsFrameProps) => (
    <ThemeProvider theme={AxleV2Theme}>
        <AxlePage noPadding fillShell>
            <AxleErrorBoundary fallback={<ErrorFallback />}>
                <Box sx={{ display: 'flex', alignItems: 'stretch', height: '100%' }}>
                    <Box
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            background: WHITE,
                        }}
                    >
                        {header}
                        <Box sx={{ flex: 1, minHeight: 0, position: 'relative' }}>
                            <Box sx={{ height: '100%', overflowY: 'auto' }}>
                                <VerticalStack spacing={3} p={2}>
                                    {children}
                                </VerticalStack>
                            </Box>
                            {overlay}
                        </Box>
                    </Box>
                    {rightRail}
                </Box>
            </AxleErrorBoundary>
        </AxlePage>
    </ThemeProvider>
);
